<template>
  <div>
    <embed-api-table
    title="PR / Guest Post Articles"
    module="Client-Pages"
    v-bind:add-new-text="addNewText"
    @add-new="addNew"
    default-sort="createdAt DESC"
    v-bind:per-page="perPage"
    v-bind:columns="articlesColumns"
    v-bind:filter="articlesFilter"
    v-bind:refresh-for-id="lastRefreshTime">
    </embed-api-table>

    <article-data @added="onArticleAdded" v-bind:client-id="clientId"></article-data>
  </div>
</template>

<script>
  import EmbedApiTable from "./EmbedApiTable.vue";
  import WebLLCRESTApi from "../api/api";
  import ArticleData from "./ArticleData.vue";
  import $ from "jquery";
  
  
  export default {
    props: {
      clientId: String,
      canSave: Boolean
    },
    created() {
      // prepare api
      this.api = new WebLLCRESTApi("Client-Pages", this.$router);
    },
    
    
    data() {
      return {
        addNewText: (this.canSave ? "Add New Articles" : null),
        
        articlesColumns: this.getColumns(),
        
        articlesFilter: { category: "article", clientId: this.clientId },
        perPage: 10,
        
        lastRefreshTime: "0"
      };
    },
    
    
    methods: {
      addNew() {
        $('#modal-add-article-data').modal('toggle');
      },
      
      onArticleAdded() {
        // change the last refresh date so the table refreshes
        this.lastRefreshTime = Date.now().toString();
      },
      
      getColumns() {
        const cols = [
          { key: "url", "text": "Published URL", type: "String", sort: true },
          { key: "createdAt", "text": "Added", type: "Date", sort: true }
        ];
        
        if(this.canSave) {
          cols.unshift({ key: "bulkdelete", "text": "", type: "BulkDelete" });
          cols.push({ key: "delete", "text": "Delete", type: "Delete", sort: false });
        }
        
        return cols;
      }
    },
    
    watch: {
      canSave(to, from) {
        this.addNewText = (this.canSave ? "Add New Articles" : null);
        this.articlesColumns = this.getColumns();
      }
    },

    components: {
      EmbedApiTable,
      ArticleData
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/ArticlesTable.vue